import "babel-polyfill";

import "../../utils/window";
import LoadingIndicator from "../../views/generic/loading-indicator";
import App from "./app";

// app initializer
const init = () => {
  new LoadingIndicator();

  // finally, instantiate and start the application
  new App().start();
};

$(document).ready(init);
